'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var onClick = props.onClick,
        _props$href = props.href,
        href = _props$href === undefined ? 'javascript:;' : _props$href,
        _props$statusClassNam = props.statusClassName,
        statusClassName = _props$statusClassNam === undefined ? '' : _props$statusClassNam,
        _props$label = props.label,
        label = _props$label === undefined ? '' : _props$label;


    return _react2.default.createElement(
        'li',
        {
            onClick: onClick
        },
        _react2.default.createElement(
            'a',
            { href: href, className: statusClassName },
            label
        )
    );
}; /**
   * Tencent is pleased to support the open source community by making SPA UI available.
   * Copyright (C) 2019, a Tencent company. All rights reserved.
   */